import type {DefaultOptions} from '../../../types';
import type {TextOrSelectValueEditorLocalizations, TextOrSelectValueEditorOptions} from './types';

/**
 * @ngdoc constant
 * @name TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.text-or-select
 *
 * @description
 * For description see {@link TextOrSelectValueEditorOptions}
 *
 * ```javascript
 * {
 *      canDoAction: false,
 *      dataSource: () => Promise.resolve([]),
 *      disableRequireIfFormContains: '',
 * }
 * ```
 */
export const TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<TextOrSelectValueEditorOptions> = {
    canDoAction: false,
    dataSource: () => Promise.resolve([]),
    disableRequireIfFormContains: '',
};

/**
 * @ngdoc constant
 * @name TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.text-or-select
 *
 * @description
 * ```
 * {
 *      select: 'Select...',
 *      orType: 'or type...',
 *      selectOptionOrTypeManually: 'select any suggested option or type value manually',
 *      suggestedOptions: 'suggested options',
 *      description: ''
 * }
 * ```
 */
export const TEXT_OR_SELECT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TextOrSelectValueEditorLocalizations>({
    select: 'Select...',
    orType: 'or type...',
    selectOptionOrTypeManually: 'select any suggested option or type value manually',
    suggestedOptions: 'suggested options',
    description: ''
});